import React from "react";
import {Formik} from "formik";
import {Button, Col, Row} from "react-bootstrap";
import * as Yup from "yup";
import MySwal from "sweetalert2";
import {recoverPassword} from "../../../services/users";
import {useTranslation} from "react-i18next";

// React Components
import Input from "../../../components/Input";
import ErrorMessage from "../../../components/ErrorMessage";

// CSS Files
import "./styles.css";

const PasswordRecoveryForm = (props) => {
   const { t } = useTranslation();

   return <div className={"PasswordRecoveryForm"}>
      <Row>
         <Col xs={10} sm={9} md={7} lg={5} className={"mx-auto mb-2"}>
            <h1 className={"text-white mb-1"}>{t('recover_password_page.recover_password')}</h1>
            <p className={"recovery-info"}>{t('recover_password_page.notice')}</p>
         </Col>
      </Row>

      <Row>
         <Col xs={10} sm={9} md={7} lg={5} className={"mx-auto"}>
            <Formik
               initialValues={{email: ''}}
               validationSchema={Yup.object({
                  email: Yup.string()
                  .required(t('common.form.errors.mandatory_field'))
                  .email(t('common.form.errors.invalid_email'))
               })}
               onSubmit={(values) => {
                  recoverPassword(values.email).then(r => {
                     MySwal.fire({
                        heightAuto: false,
                        titleText: t('common.success'),
                        text: t('recover_password_page.success')
                     }).then((res) => {
                        props.setPage("login");
                     });
                  });
               }}
            >
               {formik => (
                  <form onSubmit={formik.handleSubmit}>
                     <Input
                        id={"email"}
                        name={"email"}
                        inputType={"email"}
                        placeHolder={t('common.form.labels.email')}
                        inputTextValue={formik.values.email}
                        handleChange={formik.handleChange}
                        handleOnBlur={formik.handleBlur}
                     />
                     <ErrorMessage errors={formik.errors} touched={formik.touched} name={"email"}/>

                     <Button className={"w-100 mt-1 mb-3 login-button"} type="submit" variant={"primary"}>{t('recover_password_page.recover_password')}</Button>
                  </form>
               )}
            </Formik>
         </Col>
      </Row>

      <Row>
         <Col xs={12} className={"text-center mb-2"}>
            <p className={"links"} onClick={() => props.setPage("registration")}>{t('login_page.unregistered')}</p>
         </Col>
         <Col xs={12} className={"text-center"}>
            <p className={"links"} onClick={() => props.setPage("login")}>{t('login_page.already_registered')}</p>
         </Col>
      </Row>
   </div>
}

export default PasswordRecoveryForm;